import { over } from 'stompjs';
import SockJS from 'sockjs-client';
import { wsHostUrl } from '../../../../constants/constants';
import { v4 as uuidv4 } from 'uuid';

let stompClient = null;
let threadId = uuidv4();
let subscribedIdList = [];
let connectionPromise = null;

const connect = (onConnected, onError) => {
    console.log(wsHostUrl);
    let sock = new SockJS(wsHostUrl);
    stompClient = over(sock);

    connectionPromise = new Promise((resolve, reject) => {
        stompClient.connect({}, () => {
            onConnected();
            resolve();
        }, onError);
    });

    setThreadId(uuidv4());
    // stompClient.debug = function(str) {
    //     // Do nothing, effectively silencing the logging
    // };
};

const ensureConnected = async () => {
    if (connectionPromise) {
        await connectionPromise;
    }
};

const subscribeToThread = async (subscriptionUri, onMessageReceived) => {
    await ensureConnected();
    debugger
    if (!subscribedIdList.includes(subscriptionUri + threadId)) {
        stompClient.subscribe(subscriptionUri + threadId, onMessageReceived);
        subscribedIdList.push(subscriptionUri + threadId);
    }
};

const subscribeToId = async (subscriptionUri, id, onMessageReceived) => {
    await ensureConnected();
    if (!subscribedIdList.includes(subscriptionUri + id)) {
        stompClient.subscribe(subscriptionUri + id, onMessageReceived);
        subscribedIdList.push(subscriptionUri + id);
    }
};

const subscribeToChatHistory = async (user, onHistoryReceived) => {
    await ensureConnected();
    stompClient.subscribe('/chat-box/history/' + user.id + "/" + user.departmentId, onHistoryReceived);
};

const sendMessage = async (senderPrefix, message) => {
    await ensureConnected();
    if (stompClient) {
        stompClient.send(senderPrefix, {}, JSON.stringify(message));
    }
};

const sendMessageEndChat = async (message) => {
    await ensureConnected();
    if (stompClient) {
        await stompClient.send('/agent-message', {}, JSON.stringify(message));
        stompClient.send('/remove-threadId', {}, JSON.stringify(message));
    }
}

const sendLogoutMessage = async (senderPrefix, message) => {
    await ensureConnected();
    if (stompClient) {
        stompClient.send(senderPrefix, {}, JSON.stringify(message));
        disconnectWS();
    }
};

const disconnectWS = () => {
    if (stompClient) {
        stompClient.disconnect();
        stompClient = null;
        subscribedIdList = [];
        connectionPromise = null;
    }
};

const setThreadId = (tId) => {
    threadId = tId;
};

const handleTyping = async (senderPrefix, message) => {
        await ensureConnected();
        console.log("Sending typing message:", message);
        debugger
        if (stompClient) {
            console.log("Sending typing message:", message);
            stompClient.send( senderPrefix, {}, JSON.stringify(message));
        };
    }



   



export { connect, subscribeToThread , sendMessage,sendLogoutMessage, disconnectWS , threadId ,subscribeToChatHistory,setThreadId,subscribeToId,stompClient, sendMessageEndChat, handleTyping};
